<!-- 我的服务列表 -->
<template>
  <div class="contentBox">
    <!-- 表格数据 -->
    <div class="tableBox">
      <!-- 我的服务 -->
      <div class="innovationVoucher">
        <img src="@/assets/images/table-tab.png" width="8px" height="23px" />
        <span>我的服务</span>
      </div>
      <!-- Tabs标签组件 -->
      <Tabs :tabs="tabsList" @tab-click="tabClick">
        <template v-slot:button>
          <el-button size="medium" type="primary" @click="addexchange"
            icon="el-icon-circle-plus-outline">新增服务</el-button>
        </template>
        <JRtable :table-data="currentUsersData" @page-change="handlePageChange" :selection="false"
          :show-pagination="true" :column="currentUsersColumns" :pageOptions="serchParams" size="mini" :border="true"
          :index="true">
          <template slot="slot_record_tools" slot-scope="data">
            <!-- <el-button size="mini" @click="handleDetail(data.scope.row, 1)" type="success"
              v-if="serchParams.fwzt == '004'" icon="el-icon-setting">申请上架</el-button> -->
            <!-- <el-button size="mini" type="primary" @click="handlePublish(data.scope.row, '001')" v-if="serchParams.fwzt == '004'">发布</el-button> -->
            <el-button size="mini" @click="handleDetail(data.scope.row,'return')" type="primary" icon="el-icon-view"  v-if="serchParams.fwzt == '012'">编辑
            </el-button>
            <el-button size="mini" @click="handleDetail(data.scope.row,'see')" type="primary" icon="el-icon-view">查看
            </el-button>
            <el-button size="mini" type="warning" @click="handlePublish(data.scope.row, '005')"
              v-if="serchParams.fwzt == '003'" icon="el-icon-setting">申请下架 </el-button>
            <!-- <el-button size="mini" type="danger" @click="handleDelete(data.scope.row)" v-if="serchParams.fwzt == '002,102'"
              icon="el-icon-delete">删除 </el-button> -->
            <!-- <el-button size="mini" @click="handleAudit(data.scope.row)" v-if="serchParams.fwzt == '001'">审核 </el-button> -->
          </template>
        </JRtable>
      </Tabs>

      <!-- 新增弹框 -->
      <Dialog v-if="showDialog" :visible.sync="showDialog" width="1400px" :title="dialogTitle + '服务基本信息'"
        :showBtn="true" @close="handleCancelForm" :append-to-body="true" @confirm="handleConfirm"
        @cancel="handleCancelForm">
        <template #content>
          <div class="applyform">
            <el-form  :rules="ruleExchangeForm2" label-width="100px"
              class="demo-ruleForm">
              <!-- 审核不通过原因 -->
              <el-card class="box-cards" v-if="exchangeForm.fwzt === '002' || exchangeForm.fwzt === '012'">
                  <div slot="header" class="card-title">
                    <div></div>
                    <span style="color:red">审核不通过原因</span>
                  </div>
                  <!-- 服务机构信息 -->
                  <el-row>
                    <el-col :span="24">
                      <el-form-item label="原因：" label-width="100px" > <el-input v-model.trim="exchangeForm.bhsm"
                          style="width: 830px" clearable disabled type="textarea" :autosize="{ minRows: 3, maxRows: 5  }"></el-input> </el-form-item></el-col>
                  </el-row>
              </el-card>  
              <!-- 服务机构信息 -->
              <el-card class="box-cards">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>服务机构信息</span>
                </div>
                <!-- 服务机构信息 -->
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="服务机构名称：" label-width="200px" prop="jgmc"> <el-input
                        v-model.trim="currentJgInfo.jgmc" style="width: 850px" clearable disabled></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row>
                  <el-col :span="10">
                    <el-form-item label="服务机构联系电话：" label-width="200px" prop="jglxrdh"> <el-input
                        v-model.trim="currentJgInfo.jglxrdh" style="width: 300px" clearable disabled></el-input>
                    </el-form-item></el-col>
                  <el-col :span="10">
                    <el-form-item label="服务机构联系人：" label-width="200px" prop="jglxr"> <el-input
                        v-model.trim="currentJgInfo.jglxr" style="width: 300px" clearable disabled></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="服务机构类型：" label-width="200px" prop="fwjglxList">
                      <span v-for="(item, index) in currentJgInfo.fwjglxList" :label="item" :key="item">{{ index + 1
                        }}、{{ item }}<br /></span> </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col>
                    <el-form-item label="服务领域：" label-width="200px" prop="sszylyList">
                      <!-- <template v-if="currentJgInfo.sscylyDetail != ''">
          <span> 其他：{{ currentJgInfo.sscylyDetail }}<br /></span>
        </template> -->
                      <template>
                        <span v-for="(item, index) in currentJgInfo.sszylyList" :key="item"> {{ index + 1 }}、{{ item
                          }}<br /></span>
                      </template> </el-form-item></el-col>
                </el-row>
              </el-card>
            </el-form>
            <el-form :model="exchangeForm" :rules="ruleExchangeForm" ref="ruleForm" label-width="100px"
              class="demo-ruleForm">
              <!-- 服务基本信息 -->
              <el-card class="box-cards">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>服务基本信息</span>
                </div>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="服务名称：" prop="fwmc" label-width="200px">
                      <el-input v-model.trim="exchangeForm.fwmc" style="width: 970px" clearable
                        :disabled="isDisabled"></el-input>
                    </el-form-item></el-col>
                </el-row>                
                <!-- <el-row :gutter="20"> -->
                  <!-- <el-col :span="12">
                    <el-form-item label="服务名称：" prop="fwmc" label-width="200px">
                      <el-input v-model.trim="exchangeForm.fwmc" style="width: 400px" clearable
                        :disabled="isDisabled"></el-input>
                    </el-form-item></el-col> -->
                  <!-- <el-col :span="12">
                    <el-form-item label="服务类型：" prop="fwlx" label-width="200px">
                      <el-cascader ref="fAddress2" v-model.trim="exchangeForm.fwlx" :options="options"
                        :props="cityDictProps" style="width: 300px" :disabled="isDisabled" @change="handleChangeFwLx">
                      </el-cascader>
                    </el-form-item></el-col> -->
                <!-- </el-row> -->

                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="参考价格(元)：" prop="ckjg" label-width="200px">
                      <el-input-number v-model.trim="exchangeForm.ckjg" :min="0" :disabled="isDisabled"
                        style="width: 300px" @input="clearMinPriceRule"></el-input-number>
                      <!-- <el-input v-model.trim="exchangeForm.ckjg" :disabled="isDisabled" style="width: 300px"
                        clearable>
                      </el-input> -->
                      <span style="margin-left: 6px;font-size: 15px;font-weight: bold;">元</span>                      
                    </el-form-item></el-col>
                  <el-col :span="12">
                    <el-form-item label="最高价格(元)：" prop="ckjgMax" label-width="200px">
                      <el-input-number v-model.trim="exchangeForm.ckjgMax" :min="0" :disabled="isDisabled"
                        style="width: 300px" @input="clearMaxPriceRule">
                      </el-input-number> 
                      <span style="margin-left: 6px;font-size: 15px;font-weight: bold;">元</span> 
                    </el-form-item></el-col>
                  <!-- <el-col :span="10">
                    <el-form-item label="服务来源：" prop="fwly" label-width="200px">
                      <el-input :disabled="isDisabled" v-model.trim="exchangeForm.fwly" style="width: 300px" clearable></el-input> </el-form-item
                  ></el-col> -->
                </el-row>
                <el-row :gutter="20" style="margin-bottom: 20px;">
                  <el-col :span="12">
                    <el-form-item label="服务类型：" prop="fwlx" label-width="200px" >
                      <el-cascader v-if="!isDisabled" ref="fAddress2" v-model="exchangeForm.fwlx" :options="options"
                        :props="cityDictProps" style="width: 300px" :disabled="isDisabled" @change="handleChangeFwLx">
                      </el-cascader>
                      <el-input v-else v-model.trim="exchangeForm.fwlxNames" style="width: 300px" clearable disabled></el-input>
                    </el-form-item></el-col>        
                  <el-col :span="12 ">
                    <el-form-item label="服务照片：" prop="fwtpPath" label-width="200px" style="margin-bottom: 0px;">
                      <el-upload class="avatar-uploader" :action="upload_Fwtp.action" :data="{ fwid: exchangeForm.fwid }" :headers="upload_Fwtp.token"  :show-file-list="false"
                      :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :disabled="isDisabled">
                        <img v-if="exchangeForm.fwtpPath" :src="exchangeForm.fwtpPath" class="avatar" />
                        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                      </el-upload>
                    </el-form-item></el-col>
                  <el-col :offset="16">
                    <br />
                    <span style="color: red;">
                      *建议上传JPG/PNG文件，且不超过2MB
                    </span>
                  </el-col>
                </el-row>
                <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                  <el-col>
                    <el-form-item label="应用领域：" prop="yyly" label-width="200px" class="groupClass fwlyStyle">
                      <el-checkbox-group v-model="exchangeForm.yyly" :disabled="isDisabled">
                        <el-checkbox v-for="(option, index) in yylyList" :key="index" :label="option.dictCode">{{
                          option.dictValue
                          }}</el-checkbox>
                        <!-- 点击其他按钮才会展示输入框信息 -->
                        <template v-if="exchangeForm.yyly.includes('99')">
                          <el-input v-model.trim="exchangeForm.yylyDetail" style="width: 200px;margin-left: 10px;"
                            size="mini" :disabled="isDisabled"></el-input>
                        </template>
                      </el-checkbox-group>
                    </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                  <el-col>
                    <el-form-item label="设备分类（可多选）：" prop="sbfl" label-width="200px" class="groupClass fwlyStyle">
                      <el-checkbox-group v-model="exchangeForm.sbfl" :disabled="isDisabled">
                        <el-checkbox v-for="(option, index) in sbflList" :key="index" :label="option.dictCode">{{
                          option.dictValue
                          }}</el-checkbox>
                      </el-checkbox-group>
                    </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                  <el-col :span="10">
                    <el-form-item label="设备原值：" prop="sbyz" label-width="200px">
                      <el-input v-model.trim="exchangeForm.sbyz" style="width: 300px" :disabled="isDisabled">
                        <template slot="append">万元</template>
                      </el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="12">
                    <el-form-item label="联系人：" prop="lxr" label-width="200px">
                      <el-input v-model.trim="exchangeForm.lxr" style="width: 300px" clearable
                        :disabled="isDisabled"></el-input>
                    </el-form-item></el-col>
                  <el-col :span="12">
                    <el-form-item label="联系人手机号码：" prop="lxdh" label-width="200px">
                      <el-input v-model.trim="exchangeForm.lxdh" style="width: 300px" clearable
                        :disabled="isDisabled"></el-input>
                    </el-form-item></el-col>
                </el-row>
                <el-row :gutter="20" v-if="exchangeForm.fwlx[0] === '01'">
                  <el-col :span="24">
                    <el-form-item label="所在地区：" prop="lxdz" label-width="200px">
                      <el-cascader ref="fAddress" v-model="fwdz" :options="divisionHbDictList" :props="cityDictProps"
                        style="width: 250px" disabled>
                      </el-cascader>
                      <el-input :disabled="isDisabled" v-model.trim="exchangeForm.lxdz"
                        style="width: 400px;margin-left: 10px;" clearable></el-input>
                    </el-form-item></el-col>
                  <!-- <el-col :span="10">
                    <el-form-item label="认证资质：" prop="rzzz" label-width="200px">
                      <el-input :disabled="isDisabled" v-model.trim="exchangeForm.rzzz" style="width: 300px" clearable></el-input> </el-form-item
                  ></el-col> -->
                </el-row>
                <el-row :gutter="20">
                  <el-col :span="24">
                    <el-form-item label="服务简介：" prop="fwjj" label-width="200px">
                      <el-input :disabled="isDisabled" v-model="exchangeForm.fwjj" style="width: 840px" type="textarea"
                        :autosize="{ minRows: 5, maxRows: 8 }" maxlength="500" show-word-limit></el-input>
                    </el-form-item></el-col>
                  <el-col :span="24">
                    <el-form-item label="服务内容：" prop="fwnr" label-width="200px">
                      <el-input :disabled="isDisabled" v-model="exchangeForm.fwnr" style="width: 840px" type="textarea"
                        :autosize="{ minRows: 5, maxRows: 8 }" maxlength="500" show-word-limit></el-input>
                    </el-form-item></el-col>

                  <!-- <el-col :span="10">
                  <el-form-item label="服务资质:" prop="fwzz" label-width="200px">
                    <el-input :disabled="isDisabled" v-model="exchangeForm.fwzz" style="width: 300px" clearable></el-input> </el-form-item
                ></el-col> -->
                </el-row>
              </el-card>
              <el-row :gutter="0" v-if="false">
                <el-col :span="10" v-if="false">
                  <el-form-item label="驳回说明:" prop="bhsm" label-width="200px">
                    <el-input :disabled="isDisabled" v-model.trim="exchangeForm.bhsm" style="width: 250px"
                      clearable></el-input>
                  </el-form-item></el-col>
                <el-col :span="24">
                  <el-form-item label="服务资质：" prop="fwzz" label-width="200px">
                    <el-upload class="upload-demo" action="#" :on-remove="handleRemove" :before-remove="beforeRemove"
                      :on-change="handleChange" :on-preview="handlePreview" multiple :file-list="fileList"
                      :http-request="handleSuccess" :disabled="isDisabled">
                      <el-button size="small" type="primary" :disabled="isDisabled">点击上传</el-button>
                      <div slot="tip" class="el-upload__tip" style="color: red" v-if="fileIdList.length">
                        提示：上传的文件，可以点击文件来进行下载、预览文件信息。</div>
                    </el-upload>
                  </el-form-item>
                </el-col>
              </el-row>
              <!-- 服务资质文件 -->
              <el-card class="box-cards upload-attachments" v-if="dialogTitle !== '查看'">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>服务资质文件</span>
                  <span
                    style="color: red; font-weight: bold; font-size: 16px; margin-left: 10px">注：以下是当前机构的资质证明材料。</span>
                </div>
                <template v-for="item in wjlxList">
                  <el-row :gutter="50" :key="item.dictCode" v-if="item.isShow">
                    <el-col :span="8"><span class="upload-title">{{ item.dictValue }}</span></el-col>
                    <el-col :span="12" style="display: flex; flex-direction: column; align-items: flex-start">
                      <div class="up-list_item">
                        <el-checkbox-group v-model="item.fileList2" disabled>
                          <div class="up-list_item_row" v-for="(item2, index2) in item.fileList" :key="index2">
                            <div class="fileName">
                              <el-checkbox :label="item2.fjid" :disabled="isDisabled">{{ item2.wjm }} （{{ item2.wbdx |
                                bytesToKB
                                }}）</el-checkbox>
                              <el-link type="success" @click="previewFile(item2.fjid)">预览 </el-link>
                            </div>
                          </div>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                  </el-row>
                </template>
              </el-card>
              <!-- 服务资质文件 -->
              <el-card class="box-cards upload-attachments" v-if="dialogTitle === '查看'">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>服务资质文件</span>
                </div>
                <template v-if="wjlxList2.length > 0">
                  <el-row :gutter="50" v-for="(item, index) in wjlxList2" :key="index">
                    <el-col :span="12" style="display: flex; flex-direction: column; align-items: flex-start">
                      <div class="up-list_item">
                        <div class="up-list_item_row">
                          <div class="fileName">
                            <!-- <span>{{ index + 1 }}、{{ item.wjm }} （{{ item.wjdx | bytesToKB }}）</span> -->
                            <span>{{ index + 1 }}、{{ item.wjm }} （{{ item.wjdx | bytesToKB }}）</span>
                            <el-link type="success" @click="previewFile2(item.id)">预览 </el-link>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                </template>
                <template v-else>
                  <span>暂无相关资质文件</span>
                </template>
              </el-card>  
              <!-- 退回服务资质文件 -->
              <el-card class="box-cards upload-attachments" v-if="isReturn">
                <div slot="header" class="card-title">
                  <div></div>
                  <span>服务资质文件</span>
                  <span
                    style="color: red; font-weight: bold; font-size: 16px; margin-left: 10px">注：以下是当前机构的资质证明材料。</span>
                </div>
                <template v-for="item in wjlxList">
                  <el-row :gutter="50" :key="item.dictCode" v-if="item.isShow">
                    <el-col :span="8"><span class="upload-title">{{ item.dictValue }}</span></el-col>
                    <el-col :span="12" style="display: flex; flex-direction: column; align-items: flex-start">
                      <div class="up-list_item">
                        <el-checkbox-group v-model="item.fileList2" disabled>
                          <div class="up-list_item_row" v-for="(item2, index2) in item.fileList" :key="index2">
                            <div class="fileName">
                              <el-checkbox :label="item2.fjid">{{ item2.wjm }} （{{ item2.wbdx |
                                bytesToKB
                                }}）</el-checkbox>
                              <el-link type="success" @click="previewFile(item2.fjid)">预览 </el-link>
                            </div>
                          </div>
                        </el-checkbox-group>
                      </div>
                    </el-col>
                  </el-row>
                </template>
              </el-card>              
            </el-form>
          </div>
        </template>
        <template #footer>
          <div v-if="isDisabled">
            <el-button size="small" @click="handleCancelForm">取 消</el-button>
            <el-button size="small" @click="handleConfirm" type="primary"  v-if="isReturn">确 定</el-button>
          </div>
        </template>
      </Dialog>
      <!-- 验证码校验规则 -->
      <el-dialog :visible.sync="showDialog2" width="500px" :show-close="false" class="newDialog">
        <newDialog :visible.sync="showDialog2" title="身份验证" @closeDialog="closeDialog2" @confirm="confirmIdentity"
          :showCancelBtn="true" :showConfirmBtn="true">
          <template v-slot:tb>
            <img src="@/assets/images/approval.png" alt="" />
          </template>
          <!-- 弹窗内容 -->
          <el-form label-width="90px" :model="resetLoginForm" :rules="resetLoginRules"
            style="margin: 5px 0px 0px -80px">
            <el-form-item prop="phoneNumber">
              <el-input v-model.trim="resetLoginForm.phoneNumber" placeholder="手机号" name="phoneNumber" type="text"
                tabindex="1" auto-complete="on" disabled><span slot="prefix" class="svg-container"><svg-icon
                    icon-class="phone" /></span></el-input>
            </el-form-item>
            <el-form-item prop="smsCode">
              <el-row :gutter="25">
                <el-col :span="16">
                  <el-input v-model.trim="resetLoginForm.smsCode" placeholder="短信验证码" name="smsCode" type="text"
                    tabindex="1" auto-complete="on">
                    <span slot="prefix" class="svg-container"><svg-icon icon-class="message" /></span>
                  </el-input>
                </el-col>
                <el-col :span="8">
                  <el-button @click="handleGetSmsCode" :disabled="interval !== null" style="height: 100%"
                    type="primary"><span>{{ interval ? timeout + '秒后重试' : '获取验证码' }}</span>
                  </el-button>
                </el-col>
              </el-row>
            </el-form-item>
          </el-form>
        </newDialog>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import JRtable from '@/components/Table'
import Tabs from '@/components/Tabs'
import Dialog from '@/views/enterprise/components/Dialog'
import { getMyServiesList, applyServies, getServiesDetail, auditServies, deleteServies, getNumList, getMountJg, getFwlxDictList } from '../../../api/mechanism/myServies'
import { getDictionaryList, recursionDictData } from '@/api/enterprise/exchangelist'
import { getJgFileList, printPdfView, printPdfView2 } from '@/api/mechanism/enterApply'
import { getToken } from '@/utils/cache'
import { mapGetters } from 'vuex'
import { getDqJgDetail } from '@/api/mechanism/indexCenter.js'
import newDialog from '@/components/newDialog'
import { getFwSmsCode, validateMsgAuthCode } from '@/api/user.js'
import { Debounce } from '@/utils'
import { contactUser } from '@/utils/jr-validate'
export default {
  components: {
    JRtable,
    Tabs,
    Dialog,
    newDialog
  },
  data() {
    return {
      upload_Fwtp: {
        action: process.env.VUE_APP_BASE_API + process.env.VUE_APP_PREFIX_API_SC + '/ticketMain/api/factFwjbxxb/uploadFwtp',
        token: {
          Internettoken: getToken()
        }
      },
      interval: null,
      timeout: 60,
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      dialogTitle: '新增',
      // 我的兑付情况
      currentUsersData: [],

      // 顶部横向tabs切换栏目
      tabsList: [
        {
          id: '003',
          value: '发布中',
          isActive: true,
          quantity: 0
          // permission: ['编辑', '查看']
        },
        {
          id: '004',
          value: '已下架',
          isActive: false,
          quantity: 0
          // permission: ['查看']
        },
        {
          id: '001,101,005,105',
          value: '审核中',
          isActive: false,
          quantity: 0
          // permission: ['编辑']
        },
        {
          id: '012',
          value: '资质退回',
          isActive: false,
          quantity: 0
          // permission: ['编辑']
        },
        {
          id: '002,102',
          value: '审核不通过',
          isActive: false,
          quantity: 0
          // permission: ['评价', '查看']
        }
      ],
      // 是否显示dialog
      showDialog: false,
      // 是否显示dialog2
      showDialog2: false,
      // 兑付表单对应的form信息
      exchangeForm: {
        fwid: '', // 服务ID
        fwmc: '', // 服务名称
        fwjj: '', // 服务简介
        lxr: '', // 联系人
        lxdh: '', // 联系电话
        lxdz: '', // 联系地址
        fwszs: '',//服务所在市
        fwszqy: '',//服务所在区
        fwnr: '', // 服务内容
        rzzz: '', // 认证资质
        cjsj: '', // 创建时间
        jgid: '', // 机构ID
        fwlx: [], // 服务类型
        fwlxNames: '', // 服务类型
        fwzt: '001', // 服务状态
        fbsj: '', // 发布时间
        shsj: '', // 审核时间
        bhsm: '', // 驳回说明
        fwzz: '', // 服务资质
        fwly: '', // 服务来源
        ckjg: '', // 参考价格
        ckjgMax: '', // 最高参考价格
        fwtpPath: '', // 服务图片
        fwtp: '',
        auditState: '', // 审核状态0不通过1通过,
        jgFileId: '', //文件id（逗号拼接）,
        sbfl: [],//设备分类
        sbyz: '',//设备原值
        yyly: [],//应用领域
        yylyDetail: '',//应用领域说明
      },
      // 兑付申请表 所需的 form 验证规则
      ruleExchangeForm: {
        fwmc: [{ required: true, message: '请输入服务名称', trigger: 'blur' }],
        fwjj: [{ required: true, message: '请输入服务简介', trigger: 'blur' },
        { pattern: /^[\s\S]{50,}$/, message: '请输入至少50个字符', trigger: 'blur' }
        ],
        lxr: [{ required: true, message: '请输入联系人', trigger: 'blur' },
        { validator: contactUser, trigger: 'blur' },
        ],
        lxdh: [
          { required: true, message: '请输入联系手机号码', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        lxdz: [{ required: true, message: '请输入联系地址', trigger: 'blur' }],
        fwnr: [{ required: true, message: '请输入服务内容', trigger: 'blur' },
        { pattern: /^[\s\S]{50,}$/, message: '请输入至少50个字符', trigger: 'blur' }
        ],
        fwlx: [{ required: true, message: '请选择服务类型', trigger: 'change' }],
        ckjg: [{ required: true, message: '请输入参考价格', trigger: 'blur' },
        { validator: this.validateMinPrice, trigger: 'blur' }
        ],
        ckjgMax: [{ required: true, message: '请输入参考价格', trigger: 'blur' },
        { validator: this.validateMaxPrice, trigger: 'blur' }],
        fwtpPath: [{ required: true, message: '请上传服务照片', trigger: 'change' }],
        rzzz: [{ required: true, message: '请输入认证资质', trigger: 'blur' }],
        fwzz: [{ required: true, message: '请上传服务资质', trigger: 'change' }],
        // fwzz: [{ required: true, validator: validateImage, trigger: 'change' }],

        fwly: [{ required: true, message: '请输入服务来源', trigger: 'blur' }],
        bhsm: [{ required: true, message: '请输入驳回说明', trigger: 'blur' }],
        fwzt: [{ required: true, message: '请输入服务状态', trigger: 'blur' }],
        fwid: [{ required: true, message: '请选择服务机构', trigger: 'change' }],
        sbfl: [{ required: true, message: '请选择设备分类', trigger: 'change' }],
        yyly: [{ required: true, message: '请选择应用领域', trigger: 'change' }],
        sbyz: [{ required: true, message: '请输入设备原值', trigger: 'blur' },
        { pattern: /^\d+(\.\d+)?$/, message: '只能输入数字类型的值', trigger: 'blur' }
        ],
      },
      // 兑付申请表 所需的 form 验证规则
      ruleExchangeForm2: {
        jgmc: [{ required: true, message: '请输入服务机构名称', trigger: 'blur' }],
        jglxrdh: [{ required: true, message: '请输入服务机构联系电话', trigger: 'blur' }],
        jglxr: [{ required: true, message: '请输入服务机构联系人', trigger: 'blur' }],
        fwjglxList: [{ required: true, message: '请输入服务机构类型', trigger: 'blur' }],
        sszylyList: [{ required: true, message: '请输入服务领域', trigger: 'blur' }],
      },      
      serchParams: {
        page: 1,
        limit: 10,
        size: 10,
        total: 0,
        fwzt: '003'
      },
      options: [],
      isDisabled: false, //查看禁止填写
      fileList: [],
      fileIdList: [], //上传文件ID
      numDetail: {},
      // 当前机构的信息
      currentJgInfo: {
        jgmc: '',
        jglxr: '',
        jglxrdh: '',
        fwjglxList: [],
        sszylyList: []
      },
      currentJgInfo2: {
        jgmc: '',
        jglxr: '',
        jglxrdh: '',
        fwjglxList: [],
        sszylyList: []
      },
      wjlxList: [], //文件类型数组
      wjlxList2: [], //已经上传的文件信息,
      // 设备类型数组
      sbflList: [],
      // 应用领域数组
      yylyList: [],
      // 服务地址数组
      fwdz: [],
      // 湖北省行政区划字典
      divisionHbDictList: [],
      cityDictProps: {
        label: 'dictValue',
        value: 'dictCode',
        children: 'childSysDictionaryList'
      },
      resetLoginForm: {
        loginType: '1',
        password: '',
        phoneNumber: '',
        smsCode: ''
      },
      resetLoginRules: {
        phoneNumber: [{ required: true, trigger: 'blur', message: '请输入手机号' }],
        smsCode: [{ required: true, trigger: 'blur', message: '请输入验证码' }]
      },
      isReturn:false
    }
  },
  filters: {
    bytesToKB: function (bytes) {
      if (bytes === 0) return '0 Bytes'
      const k = 1024
      let size = bytes / k
      let unit = 'KB'
      if (size > k) {
        size /= k
        unit = 'MB'
      }
      return size.toFixed(2) + ' ' + unit
    }
  },
  computed: {
    currentUsersColumns() {
      return [
        {
          label: '服务名称',
          prop: 'fwmc',
          align: 'center',
          // width: 180,
          truncate: true
        },
        {
          label: '联系人',
          prop: 'lxr',
          align: 'center',
          // width: 180,
          truncate: true
        },
        {
          label: '联系方式',
          prop: 'lxdh',
          // width: 180,
          align: 'center',
          truncate: true
        },

        {
          label: '参考价格（元）',
          prop: 'ckjg',
          align: 'center',
          // width: 180,
          truncate: true
        },
        // {
        //   label: '审核状态',
        //   prop: 'fwztName',
        //   align: 'center',
        //   width: 180,
        //   truncate: true
        // },
        // {
        //   label: '驳回原因',
        //   prop: 'bhyy',
        //   align: 'center',
        //   // width: 180,
        //   isHidden: this.serchParams.fwzt === '004' || this.serchParams.fwzt === '002,102' ? false : true
        // },
        {
          label: '备注',
          prop: 'bhsm',
          align: 'center',
          // width: 180,
          isHidden: this.serchParams.fwzt === '004' || this.serchParams.fwzt === '002,102' || this.serchParams.fwzt === '012' ? false : true
        },
        // {
        //   label: '发布时间',
        //   prop: 'fbsj',
        //   align: 'center',
        //   // width: 180,
        //   truncate: true
        // },
        // {
        //   label: '审核时间',
        //   prop: 'shsj',
        //   align: 'center',
        //   // width: 180,
        //   truncate: true
        // },
        // {
        //   label: '创建时间',
        //   prop: 'cjsj',
        //   align: 'center',
        //   width: 180,
        //   truncate: true
        // },
        {
          label: '服务状态',
          prop: 'fwztName',
          align: 'center',
          // width: 200,
          isHidden: this.serchParams.fwzt === '002,102' ? false : true
        },
        {
          label: '操作',
          prop: '',
          align: 'center',
          width: 250,
          // fixed: 'right',
          slot: 'slot_record_tools'
        }
      ]
    },
    // ...mapGetters(['jgzl'])
  },
  async created() {
    // 查询湖北省行政区划
    this.handleGetHbDivision()
    await this.getServiesList()
    await this.getOrgTypeList()
    await this.getMountJg()
    await this.getNumList()
    // 获取当前用户信息
    await this.getDqJgDetail()
  },

  methods: {
    validateMinPrice(rule, value, callback) {
      if (value > this.exchangeForm.ckjgMax) {
        callback(new Error('不能高于最高价格'))
      } else {
        callback()
      }
    },    
    validateMaxPrice(rule, value, callback) {
      if (value < this.exchangeForm.ckjg) {
        callback(new Error('最高价格不能低于最低价格'))
      } else {
        callback()
      }
    },    
    clearMinPriceRule() {
      this.$nextTick(()=>{
        this.$refs['ruleForm'].clearValidate('ckjgMax');
      })      
    },
    clearMaxPriceRule() {
      this.$nextTick(()=>{
        this.$refs['ruleForm'].clearValidate('ckjg');
      })      
    },    
    // 查询湖北省行政区划
    handleGetHbDivision() {
      let params = {
        parentId: '420000',
        level: '3'
      }
      recursionDictData(params).then((response) => {
        const { data } = response
        this.divisionHbDictList.push(data)
      })
    },
    // 获取机构当前信息
    async getDqJgDetail() {
      const res = await getDqJgDetail()
      this.currentJgInfo2 = res.data
      // console.log(this.currentJgInfo2.jgmc,this.currentJgInfo2.jglxrdh,'this.currentJgInfo2');

    },
    // 获取统计数据接口
    async getNumList() {
      const result = await getNumList({ isDqyh: 1 })
      this.numDetail = result.data
      this.tabsList[0].quantity = this.numDetail.fb
      this.tabsList[1].quantity = this.numDetail.xj
      this.tabsList[2].quantity = this.numDetail.shz
      this.tabsList[3].quantity = this.numDetail.zzth
      this.tabsList[4].quantity = this.numDetail.btg
    },
    // 获取字典数据
    async getOrgTypeList() {
      const result = await getFwlxDictList()
      this.options = result.data
      // 获取设备分类字典值
      const result2 = await getDictionaryList({
        parentCode: 'DIM_SBFL'
      })
      if (result2.code === 200) {
        this.sbflList = result2.data
      }
      // 获取应用领域字典值
      const result3 = await getDictionaryList({
        parentCode: 'DIM_YYLY'
      })
      if (result3.code === 200) {
        this.yylyList = result3.data
      }
      // 附件上传文件类型
      let c = await getDictionaryList({
        parentCode: 'DIM_WJLX'
      })
      if (c.code === 200) {
        this.wjlxList = c.data.filter((item) => {
          this.$set(item, 'fileList', [])
          this.$set(item, 'fileList2', [])
          this.$set(item, 'isShow', true)
          return item.dictCode === '006' || item.dictCode === '026' || item.dictCode === '027' || item.dictCode === '025'
        })
      }
    },
    // 查询机构的服务挂载机构
    async getMountJg() {
      const result = await getMountJg()
      if (result.code === 200) {
        this.currentJgInfo = result.data
        this.fwdz = result.data.jgszqy
      } else {
        this.currentJgInfo = {}
      }
      // 回显上传文件的信息
      await this.getExchangeListAttach(this.currentJgInfo.jgid)
    },
    // 分页控制
    handlePageChange(val) {
      this.serchParams.page = val.page
      this.serchParams.limit = val.limit
      this.serchParams.size = val.limit

      this.getServiesList()
    },
    // 获取分页列表
    async getServiesList() {
      const result = await getMyServiesList({ ...this.serchParams })
      // console.log(result)
      this.currentUsersData = result.data.records
      this.serchParams.total = result.data.total
    },

    // tabs栏目点击切换事件
    tabClick(item) {
      // console.log('=======点击的tab数据=========')
      this.serchParams.fwzt = item.id
      // console.log(this.serchParams.fwzt)
      this.serchParams.page = 1
      this.getServiesList()
    },
    // 点击新增
    addexchange() {
      this.isReturn = false
      this.dialogTitle = '新增'
      this.exchangeForm = {
        fwid: '', // 服务ID
        fwmc: '', // 服务名称
        fwjj: '', // 服务简介
        lxr: '', // 联系人
        lxdh: '', // 联系电话
        lxdz: this.currentJgInfo.txdz, // 联系地址
        fwszs: this.currentJgInfo.jgszs,//服务所在市
        fwszqy: this.currentJgInfo.jgszqy,//服务所在区
        fwnr: '', // 服务内容
        rzzz: '', // 认证资质
        cjsj: '', // 创建时间
        jgid: '', // 机构ID
        fwlx: [], // 服务类型
        fwlxNames: '', // 服务类型
        fwzt: '001', // 服务状态
        fbsj: '', // 发布时间
        shsj: '', // 审核时间
        bhsm: '', // 驳回说明
        fwzz: '', // 服务资质
        fwly: '', // 服务来源
        ckjg: '', // 参考价格
        ckjgMax: '', // 最高参考价格
        fwtpPath: '', // 服务图片
        fwtp: '',
        auditState: '', // 审核状态0不通过1通过
        jgFileId: '', //文件id（逗号拼接）
        sbfl: [],//设备分类
        sbyz: '',//设备原值
        yyly: [],//应用领域
        yylyDetail: '',//应用领域说明
      }
      this.showDialog = true
      this.isDisabled = false
      // this.serchParams.fwzt = '003'
      this.fileList = []
      this.fileIdList = [] //上传文件ID
      // 循环将wjList的值清空
      this.wjlxList.forEach((item) => {
        item.fileList2 = []
        item.isShow = true
      })
      // this.wjlxList.forEach((element) => {
      //     this.$set(element, 'fileList2', element.fileList.map(item => item.fjid));
      // })
    },
    handleConfirm() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          // 提取 fileList2 字段的值并组合成一个新数组
          const combinedArray = []
          this.wjlxList.forEach((item) => {
            combinedArray.push(...item.fileList2)
          })
          // 使用 join 方法将新数组的值拼接起来
          const jgFileIdResult = combinedArray.join(',')
          if (!jgFileIdResult) {
            this.$message.error('请选择要上传的服务资质')
            this.moveToErr('upload-attachments')
            return false
          }
          // 如果当前选择的是大型科学仪器的话，则需要判断服务名称
          const largeKeiXxu = ['0101', '0102', '0103', '0104']
          if (largeKeiXxu.includes(this.exchangeForm.fwlx[1])) {
            // 如果当前服务名称不是以服务结尾的就提示服务名称要以xxx服务结尾
            if (!this.exchangeForm.fwmc.endsWith('服务')) {
              this.$message.error('服务名称以"服务"结尾，请重新输入')
              return
            }
          }
          // 赋值给校验验证码的输入框
          this.resetLoginForm.phoneNumber = this.exchangeForm.lxdh
          this.resetLoginForm.smsCode = ''
          this.showDialog2 = true
        } else {
          this.moveToErr()
          return false
        }
      })
    },
    moveToErr(className = 'is-error') {
      this.$nextTick(() => {
        let isError = document.getElementsByClassName(className)
        if (isError.length) {
          isError[0].scrollIntoView({
            block: 'center',
            behavior: 'smooth'
          })
        }
      })
    },
    // 获取验证码
    handleGetSmsCode() {
      if (!this.resetLoginForm.phoneNumber) {
        this.$message.error('请填写手机号')
        return
      }
      let params = {
        phoneNumber: this.resetLoginForm.phoneNumber,
      }
      getFwSmsCode(params)
        .then((response) => {
          if (response && response.rel) {
            this.$message.success('短信验证码已发送，请注意查收')
            this.timeout = 60
            this.interval = setInterval(() => {
              this.timeout--
              if (this.timeout === 0) {
                clearInterval(this.interval)
                this.interval = null
              }
            }, 1000)
          }
        })
        .catch((error) => {
        })
    },
    // 身份认证提交方法
    confirmIdentity:Debounce(async function(){
      if (!this.resetLoginForm.smsCode) {
        this.$message.error('请输入短信验证码')
        return
      }
      // 还要先判断当前的验证码是否正确，如果正确才能往下进行，不然提示用户验证码匹配错误
      let params = {
        phoneNumber: this.resetLoginForm.phoneNumber,
        messageAuthCode: this.resetLoginForm.smsCode,
      }
      let result = await validateMsgAuthCode(params)
      if (result.code === 200) {
        // 验证通过，调用添加接口
        if (result.data === '验证通过') {
        //  this.showDialog2 = false;
         await this.addForm()
        } else {
          this.$message.error('验证码不匹配')
          this.showDialog2 = true;
          return
        }
      } else {
        this.$message.error(result.message)
        this.showDialog2 = true;
        return
      }
    },500),
    // 关闭表单
    closeDialog2() {
      this.showDialog2 = false;
      this.resetLoginForm.smsCode = ''
      this.interval = null;
    },
    // 表单的提交方法
    async addForm() {
      // 提取 fileList2 字段的值并组合成一个新数组
      const combinedArray = []
      this.wjlxList.forEach((item) => {
        combinedArray.push(...item.fileList2)
      })
      // 使用 join 方法将新数组的值拼接起来
      const jgFileIdResult = combinedArray.join(',')
      this.exchangeForm.jgFileId = jgFileIdResult
      // 处理设备分类、设备原值传值，如果选择了大型科学仪器设施共享，才会把设备分类、设备原值传值给后台
      let sbfl = ''
      if (this.exchangeForm.fwlx[0] !== '01') {
        this.exchangeForm.sbyz = ''
        sbfl = ''
      } else {
        sbfl = this.exchangeForm.sbfl.join(';')
      }
      // 之后添加的：如果选择了大型科学仪器设施共享，才会把应用领域、所在地区传值给后台
      let yyly = ''
      if (this.exchangeForm.fwlx[0] !== '01') {
        this.exchangeForm.fwszs = ''
        this.exchangeForm.fwszqy = ''
        this.exchangeForm.lxdz = ''
        yyly = ''
      } else {
        yyly = this.exchangeForm.yyly.join(';')
      }
      // this.exchangeForm.fwlx = this.exchangeForm.fwlx[1]
      this.exchangeForm.fwzz = this.fileIdList
        .map((item) => {
          return item.fileId
        })
        .join(',')
      const result = await applyServies({ ...this.exchangeForm, fwtpPath: this.exchangeForm.fwtpPath, fwzt: '001', sbfl: sbfl, yyly: yyly,fwlx: this.exchangeForm.fwlx[1]})
      if (result.code == 200) {
        this.$message.success('操作成功')
        this.showDialog = false
        this.showDialog2 = false
        this.$refs.ruleForm.resetFields()
      } else {
        this.showDialog = true
        this.showDialog2 = true
      }
      // 循环将wjList的值清空
      this.wjlxList.forEach((item) => {
        item.fileList2 = []
      })
      this.getServiesList()
      this.getNumList()
    },
    handleCancelForm() {
      this.showDialog = false
      this.$refs.ruleForm.resetFields()
    },
    // 查看详情
    async handleDetail(data, val) {
      this.showDialog = true
      // console.log(data, 'data', val)
      const result = await getServiesDetail({ fwid: data.fwid })
      this.exchangeForm = JSON.parse(JSON.stringify(result.data))
      this.exchangeForm.fwlxNames = this.exchangeForm.fwflmc
      // 回显设备分类、设备原值
      this.wjlxList2 = result.data.fwzzList
      // if (result.data.parentFwlxCode === '01') {
        if (result.data.sbfl) {
          // 展示设备分类、设备原值表单信息
          this.exchangeForm.sbfl = result.data.sbfl.split(';')
        } else {
          this.exchangeForm.sbfl = []
        }
        if (result.data.yyly) {
          // 展示应用领域
          this.exchangeForm.yyly = result.data.yyly.split(';')
        } else {
          this.exchangeForm.yyly = []
        }
      // }
      this.exchangeForm.fwlx = [result.data.parentFwlxCode, result.data.fwlx]
      // console.log(this.exchangeForm.sbfl);
      this.fileList = result.data.fwzzList.map((item) => {
        return {
          name: item.wjm,
          url: item.wjdz
        }
      })
      this.fileIdList = result.data.fwzzList.map((item) => {
        return {
          uid: item.id,
          fileId: item.id,
          name: item.wjm
        }
      })
      // this.showDialog = true
      this.dialogTitle = '编辑'
      this.isDisabled = false
      this.handleChangeFwLx(this.exchangeForm.fwlx)
      if (val==='see') {
        this.isDisabled = true
        this.dialogTitle = '查看'
        this.isReturn = false
      }
      if(val ==='return'){
        this.isDisabled = true
        this.dialogTitle = '查看'
        this.isReturn = true
      }
      // this.wjlxList.forEach((element) => {
      //     this.$set(element, 'fileList2', element.fileList.map(item => item.fjid));
      // })
    },

    // 审核
    handleAudit(data) {
      this.$confirm('审核通过吗?', '提示', {
        confirmButtonText: '通过',
        cancelButtonText: '不通过',
        type: 'warning'
      })
        .then(async () => {
          const result = await auditServies({ fwid: data.fwid, auditState: 1, fwzt: data.fwzt })
          this.$message({
            type: 'success',
            message: '审核通过'
          })
          this.getServiesList()
        })
        .catch(() => {
          this.$prompt('请输入驳回说明', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消'
          })
            .then(async ({ value }) => {
              const result = await auditServies({ fwid: data.fwid, auditState: 0, bhsm: value, fwzt: data.fwzt })
              this.$message({
                type: 'success',
                message: '驳回成功'
              })
              this.getServiesList()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消输入'
              })
            })
        })
    },
    // 发布申请下架
    handlePublish(data, val) {
      this.$confirm('此操作将下架申请, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const result = await applyServies({ ...data, fwzt: val })
          this.$message.success('下架已申请')
          this.getServiesList()
          this.getNumList()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消'
          // })
          console.log('已取消');
        })
    },

    handleDelete(data) {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const result = await deleteServies({ fwid: data.fwid })
          this.$message.success('删除成功')
          this.getServiesList()
          this.getNumList()
        })
        .catch(() => {
          // this.$message({
          //   type: 'info',
          //   message: '已取消删除'
          // })
          console.log('已取消删除');
        })
    },

    handleAvatarSuccess(res) {
      // const reader = new FileReader()
      // reader.readAsDataURL(res.file)
      // // 开始转base64
      // reader.onload = () => {
      //   this.exchangeForm.fwtpPath = reader.result
      //   this.$refs.ruleForm.validateField('jgtpPath')
      //   // base64Image.split(',')[1];
      // }
      this.exchangeForm.fwtpPath = res.data
    },
    beforeAvatarUpload(file) {
      // console.log(file.type)
      const isJPG = file.type === 'image/jpeg' || file.type === 'image/png'
      const isLt2M = file.size / 1024 / 1024 < 2

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG /png格式!')
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!')
      }
      return isJPG && isLt2M
    },
    handleRemove(file, fileList) {
      // console.log(file, fileList)
      this.fileIdList = this.fileIdList.filter((item) => item.uid !== file.uid)
    },

    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}？`)
    },
    handleChange(file, fileList) {
      console.log(file, fileList)
    },
    handleSuccess(response, file) {
      const formData = new FormData()
      formData.append('file', response.file)
      const axios = require('axios')
      axios
        .post(process.env.VUE_APP_BASE_API + 'sc/ticketMain/api/factFwjbxxb/uploadFwzzFile', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        .then((res) => {
          this.$message.success('上传成功')

          this.fileIdList.push({ uid: response.file.uid, fileId: res.data.data, name: response.file.name })
          this.exchangeForm.fwzz = this.fileIdList
            .map((item) => {
              return item.fileId
            })
            .join(',')
        })
        .catch((error) => {
          console.error('上传失败:', error)
        })
    },
    // 预览
    async handlePreview(file) {
      console.log(file)
      const obj = this.fileIdList.filter((item) => {
        return item.name === file.name
      })
      console.log(obj)
      const url = process.env.VUE_APP_BASE_API + 'sc/ticketMain/api/factFwjbxxb/previewFwzzFile?fileId=' + obj[0].fileId

      window.open(url, '_blank')
    },
    // 查看兑付详情所有的附件
    async getExchangeListAttach(val) {
      const result = await getJgFileList({
        jgid: val
      })
      const { data } = result
      if (data.length == 0) {
        this.wjlxList.forEach((element) => {
          this.$set(element, 'fileList', [])
        })
        return
      } else {
        this.wjlxList = this.mergeFilesByCode(this.wjlxList, data, 'dictCode', 'wjlx')
        this.wjlxList = this.wjlxList.filter((item) => {
          return item.fileList.length != 0
        })
        // this.wjlxList.forEach((element) => {
        //   this.$set(element, 'fileList2', element.fileList.map(item => item.fjid));
        // })
      }
    },
    // 定义一个函数来将 dataList 添加到 wjlxList 的 fileList 中
    mergeFilesByCode(wjlxList, dataList, dictCodeKey, wjlxKey) {
      // 将 dataList 按照 wjlx 分组
      const groupedData = dataList.reduce((acc, obj) => {
        const key = obj[wjlxKey]
        if (!acc[key]) {
          acc[key] = []
        }
        acc[key].push(obj)
        return acc
      }, {})

      // 遍历 wjlxList，将对应的 fileList 填充
      wjlxList.forEach((item) => {
        const wjlx = item[dictCodeKey]
        if (groupedData[wjlx]) {
          this.$set(
            item,
            'fileList',
            groupedData[wjlx].map((obj) => {
              return obj
            })
          )
        } else {
          this.$set(item, 'fileList', [])
        }
      })
      return wjlxList
    },
    // 预览文件
    previewFile(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView(paramsStr))
    },
    // 预览文件
    previewFile2(fileId) {
      let params = {
        fileId,
        InternetToken: getToken()
      }
      var paramsStr = Object.keys(params)
        .map((item) => item + '=' + params[item])
        .join('&')
      //预览文件
      window.open(printPdfView2(paramsStr))
    },
    // 改变服务类型
    handleChangeFwLx(value) {
      // 循环将wjList的值清空
      this.wjlxList.forEach((item) => {
        item.fileList2 = []
        // item.isShow = true
      })
      let fwlxIndex = value[0]
      let fjDictCode = '';
      if (fwlxIndex === '01') {
        fjDictCode = '006'
      } else if (fwlxIndex === '02') {
        fjDictCode = '025'
      } else if (fwlxIndex === '03') {
        fjDictCode = '026'
      } else if (fwlxIndex === '04') {
        fjDictCode = '027'
      }
      this.wjlxList.forEach((item) => {
        if (item.dictCode === fjDictCode) {
          item.isShow = true;
        } else {
          item.isShow = false;
        }
      })
      this.wjlxList.forEach((element) => {
        if(element.isShow){
          this.$set(element, 'fileList2', element.fileList.map(item => item.fjid));
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/form.scss';

::v-deep .title_item {
  margin-right: 20px !important;
}

.contentBox {
  width: 100%;
  height: 100%;

  .tableBox {
    margin-top: 25px;
  }
}

.innovationVoucher {
  font-weight: bold;
  display: flex;
  font-size: 18px;
  color: #333333;
  margin-bottom: 15px;

  span {
    margin-left: 10px;
  }

  :nth-child(3) {
    font-size: 14px;
    font-weight: bold;
    color: #ff0000;
    margin-left: 15px;
  }
}

.table-container {
  padding: 15px;
  // background: #fafafa;
}

::v-deep .el-table {
  // height: 68vh !important;
  overflow: auto !important;
}

::v-deep .tabs_content {
  max-height: none !important;
}

// 企业兑付申请表单样式
.applyform {
  padding: 10px;

  .box-cards {
    margin-bottom: 10px;

    .card-title {
      display: flex;
      align-items: center;

      div {
        width: 5px;
        height: 13px;
        background: rgb(88, 155, 248);
        margin-right: 10px;
      }

      span {
        font-size: 18px;
        font-weight: bold;
      }
    }
  }
}

::v-deep .el-form {
  .el-form-item {
    display: flex;
  }

  .el-form-item__content {
    margin-left: 10px !important;
  }
}

.avatar-uploader {
  line-height: 10px;
  border: 1px dashed #d9d9d9 !important;
}

.el-upload {
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}

.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
}

.avatar {
  width: 120px;
  height: 120px;
  display: block;
}

::v-deep.upload-attachments {
  .el-card__body {
    .el-row {
      min-height: 100px;
      border-bottom: 1px solid rgb(205, 211, 220);
      display: flex;
      align-items: center;

      .upload-title {
        font-weight: bold;
        font-size: 16px;
      }

      .upload-icon {
        cursor: pointer;
        font-size: 16px;
        color: rgb(86, 165, 253);

        i {
          margin-right: 5px;
        }
      }

      .upload-waring {
        color: red;
        font-size: 16px;
      }
    }
  }
}

.groupClass .el-checkbox {
  width: 110px;
}

::v-deep .fwlyStyle {
  .el-form-item__content {
    flex: 1 !important;
  }
}

::v-deep .newDialog {
  .el-dialog {
    height: 0px !important;
  }
}

.svg-container {
  height: 60px;
  // line-height: 60px;
  width: 14px;
  // margin-left: 20px;
  color: #3e8eff;
  vertical-align: middle;
  display: inline-block;
  font-size: 20px;
}
</style>
